// modules
import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Trans, withTranslation } from 'react-i18next';
import styled from 'styled-components';
import media from 'styled-media-query';
// assets
// styles
// components
import Xarrow from 'react-xarrows';
// redux

const StyledCenteredContainer = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: 500;
    text-align: right;

    p {
        margin-bottom: 8px;
    }

    ${media.lessThan('small')`
        font-size: 16px;
    `}

    ${media.between('small', 'medium')`
        font-size: 18px;
    `}

    ${media.between('medium', 'large')`
        font-size: 22px;
    `}

    ${media.greaterThan('large')`
        font-size: 24px;
    `}
`;

const StyledHintBox = styled.div`
    position: fixed;
    z-index: 2;
    background-color: rgb(163, 215, 248);
    border: 1px solid black;
    border-radius: 12px;
    line-height: 1.2;
    font-weight: 500;

    ${media.lessThan('medium')`
        display: none;
    `}

    ${media.between('medium', 'large')`
        padding: 12px;
        font-size: 16px;
    `}

    ${media.greaterThan('large')`
        padding: 12px 16px;
        font-size: 18px;
    `}
`;

const StyledArrowWrapper = styled.div`
    position: fixed;
    z-index: 2;

    ${media.lessThan('medium')`
        display: none;
    `}
`;

class ExternalAccessCourseVisualization extends Component {
    render() {
        const { currentCourse, t } = this.props;

        return (
            <div>
                <StyledCenteredContainer>
                    <div style={{ marginBottom: '24px' }}>
                        {currentCourse && currentCourse.name && (
                            <p>{currentCourse.name}</p>
                        )}
                        <p><Trans i18nKey='dashboard.externalAccess.course.visualization.text1' /></p>
                    </div>
                    <p><Trans i18nKey='dashboard.externalAccess.course.visualization.text2' /></p>
                </StyledCenteredContainer>

                <StyledHintBox id='instruction-square' style={{ left: '128px', top: '128px' }}>
                    {t('landing.header.manual')}
                </StyledHintBox>
                <StyledHintBox id='top-square' style={{ left: '128px', bottom: '112px' }}>
                    {t('dashboard.course.visualization.hint.top')}
                </StyledHintBox>
                <StyledHintBox id='bottom-square' style={{ left: '128px', bottom: '32px' }}>
                    {t('dashboard.course.visualization.hint.bottom')}
                </StyledHintBox>
                <StyledHintBox id='menu-square' style={{ right: '120px', top: '128px' }}>
                    {t('dashboard.course.visualization.hint.menu')}
                </StyledHintBox>

                {currentCourse && (
                    <>
                        {currentCourse.formulas ? (
                            <>
                                <StyledHintBox id='formulas-square' style={{ left: '128px', top: '208px' }}>
                                    {t('dashboard.course.visualization.hint.formulas')}
                                </StyledHintBox>
                                {currentCourse.extraMaterial ? (
                                    <>
                                        <StyledHintBox id='extraMaterial-square' style={{ left: '128px', top: '288px' }}>
                                            {t('dashboard.course.visualization.hint.extraMaterial')}
                                        </StyledHintBox>
                                        <StyledHintBox id='print-square' style={{ left: '128px', top: '368px' }}>
                                            {t('dashboard.course.visualization.hint.print')}
                                        </StyledHintBox>
                                        <StyledHintBox id='palette-square' style={{ left: '128px', top: '448px' }}>
                                            {t('dashboard.course.visualization.hint.palette')}
                                        </StyledHintBox>
                                    </>
                                ) : (
                                    <>
                                        <StyledHintBox id='print-square' style={{ left: '128px', top: '288px' }}>
                                            {t('dashboard.course.visualization.hint.print')}
                                        </StyledHintBox>
                                        <StyledHintBox id='palette-square' style={{ left: '128px', top: '368px' }}>
                                            {t('dashboard.course.visualization.hint.palette')}
                                        </StyledHintBox>
                                    </>
                                )}
                            </>
                        ) : (
                            <>
                                {currentCourse.extraMaterial ? (
                                    <>
                                        <StyledHintBox id='extraMaterial-square' style={{ left: '128px', top: '208px' }}>
                                            {t('dashboard.course.visualization.hint.extraMaterial')}
                                        </StyledHintBox>
                                        <StyledHintBox id='print-square' style={{ left: '128px', top: '288px' }}>
                                            {t('dashboard.course.visualization.hint.print')}
                                        </StyledHintBox>
                                        <StyledHintBox id='palette-square' style={{ left: '128px', top: '368px' }}>
                                            {t('dashboard.course.visualization.hint.palette')}
                                        </StyledHintBox>
                                    </>
                                ) : (
                                    <>
                                        <StyledHintBox id='print-square' style={{ left: '128px', top: '208px' }}>
                                            {t('dashboard.course.visualization.hint.print')}
                                        </StyledHintBox>
                                        <StyledHintBox id='palette-square' style={{ left: '128px', top: '288px' }}>
                                            {t('dashboard.course.visualization.hint.palette')}
                                        </StyledHintBox>
                                    </>
                                )}
                            </>
                        )}
                    </>
                )}

                <StyledArrowWrapper>
                    <Xarrow color='black' strokeWidth={1} headSize={10} start='instruction-square' end='instruction-button' />
                </StyledArrowWrapper>
                <StyledArrowWrapper>
                    <Xarrow color='black' strokeWidth={1} headSize={10} start='top-square' end='top-button' />
                </StyledArrowWrapper>
                <StyledArrowWrapper>
                    <Xarrow color='black' strokeWidth={1} headSize={10} start='bottom-square' end='bottom-button' />
                </StyledArrowWrapper>
                <StyledArrowWrapper>
                    <Xarrow color='black' strokeWidth={1} headSize={10} start='menu-square' end='menu-navigation-button' />
                </StyledArrowWrapper>
                <StyledArrowWrapper>
                    <Xarrow color='black' strokeWidth={1} headSize={10} start='formulas-square' end='formulas-button' />
                </StyledArrowWrapper>
                <StyledArrowWrapper>
                    <Xarrow color='black' strokeWidth={1} headSize={10} start='extraMaterial-square' end='extraMaterial-button' />
                </StyledArrowWrapper>
                <StyledArrowWrapper>
                    <Xarrow color='black' strokeWidth={1} headSize={10} start='print-square' end='print-button' />
                </StyledArrowWrapper>
                <StyledArrowWrapper>
                    <Xarrow color='black' strokeWidth={1} headSize={10} start='palette-square' end='palette-button' />
                </StyledArrowWrapper>

            </div>
        );
    }
}

const mapStateToProps = state => ({
    currentCourse: state.ui.currentCourse,
});

export default withRouter(
    compose(
        connect(mapStateToProps, null),
        withTranslation(),
    )(ExternalAccessCourseVisualization)
);
